module.exports = __webpack_public_path__ + "static/media/03_CALCINHA_ASA_DELTA_10.5bcb6162.jpg";